import { render, staticRenderFns } from "./Casting.vue?vue&type=template&id=10a826fc&"
import script from "./Casting.vue?vue&type=script&lang=js&"
export * from "./Casting.vue?vue&type=script&lang=js&"
import style0 from "./Casting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports